import React from 'react';
import LazyImage from '../../../components/LazyImage';
import useThumbnailImage from './useThumbnailImage';

const ThumbnailImage = props => {
  const { loading, error, className, imageUrl, altText, priority, handleClick } = useThumbnailImage(
    props
  );

  if (error) return error.message;
  if (loading) return null;

  return (
    <div className={className} onClick={handleClick} role="button" data-testid="thumbnail-image">
      <LazyImage
        src={imageUrl}
        alt={altText}
        sizeKey="carousel"
        role="button"
        priority={priority}
      />
    </div>
  );
};

export default ThumbnailImage;
